import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { Camera } from 'lucide-react';

const FloatingActionButton = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { hasPermission } = useAuth();

  // Only show if user can create receipts
  if (!hasPermission('receipts', 'create')) return null;

  // Show on main screens only
  const showOnRoutes = ['/dashboard', '/projects', '/receipts', '/time', '/reports', '/categories', '/'];
  const shouldShow = showOnRoutes.some(route => {
    if (route === '/') return location.pathname === '/';
    return location.pathname.startsWith(route);
  });

  // Don't show on receipt upload page or individual receipt/project pages with params
  const hideOnRoutes = ['/receipts/new', '/login', '/register', '/settings'];
  const shouldHide = hideOnRoutes.some(route => location.pathname.startsWith(route));
  
  // Hide on detail pages (routes with IDs)
  const isDetailPage = /\/(receipts|projects)\/[a-z]+_[a-f0-9]+/.test(location.pathname);

  if (!shouldShow || shouldHide || isDetailPage) {
    return null;
  }

  const handleClick = () => {
    navigate('/receipts/new');
  };

  return (
    <button
      onClick={handleClick}
      className="fab-button fixed right-4 lg:right-8 lg:bottom-8 w-14 h-14 bg-accent hover:bg-accent/90 text-background rounded-full flex items-center justify-center transition-all active:scale-95 z-30"
      style={{ boxShadow: '0 8px 20px rgba(0,0,0,0.35)' }}
      data-testid="fab-add-receipt"
      aria-label="Add receipt"
    >
      <Camera size={24} strokeWidth={2.5} />
    </button>
  );
};

export default FloatingActionButton;
